import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import {ADMIN_LANG} from "../../settings";

interface ConfirmProps {
    show: boolean;
    title?: string;
    message: string;
    itemId?: string;
    onConfirm: (itemId?: string) => void;
    onCancel: () => void;
}

const Confirm: React.FC<ConfirmProps> = ({ show, title = ADMIN_LANG.confirm_delete, message, itemId, onConfirm, onCancel }) => {
    return (
        <Modal backdropClassName="nested-backdrop" show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <div className='confirm-message' dangerouslySetInnerHTML={{__html:message}}></div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {ADMIN_LANG.cancel}
                </Button>
                <Button variant="primary" onClick={() => onConfirm(itemId)}>
                    {ADMIN_LANG.yes}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default Confirm;